<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Reflect &amp; Apply</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="rows.length > 0">
  <p class="text-muted m-b-md">
    Growth begins with awareness and matures through reflection, conversation, and
    intentional practice. Use these guiding questions over the next 90 days to clarify
    how you'll sustain momentum, strengthen growth edges, and serve others through your
    unique design.
  </p>

  <table class="table table-striped">
    <thead>
      <tr>
        <th style="width: 22%;">Focus Area</th>
        <th>Guiding Questions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td><strong>{{ row.focusArea }}</strong></td>
        <td class="font-italic">
          <p *ngFor="let q of row.questions" class="m-b-xs">
            <i class="fa fa-caret-right m-r-sm text-success" aria-hidden="true"></i>{{ q }}
          </p>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="font-italic text-muted m-t-md m-b-none">
    Capture one insight each week. After 90 days, review patterns of growth and resistance.
  </p>
</div>

<div class="modal-body" *ngIf="rows.length === 0">
  <p class="text-muted text-center m-t-md m-b-md">
    No development focus available for this archetype.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
